module.exports = __webpack_public_path__ + "static/terminal--dark_moon.91f922dbba6a489aa0b38820b02ad477.jpg";